export { default as openModal } from './openModal';
export { default as closeModal } from './closeModal';
